import type { TextShadow, TextStroke } from "../types";

export const VB_INSERT_DND_MIME = "application/x-vb-insert-detail";

export type VbInsertMode = "append" | "replace-placeholder";

export type VbTextAssetPayload = {
  text: string;
  fontSize?: number;
  fill?: string;
  align?: "left" | "center" | "right";
  fontFamily?: string;
  fontWeight?: "normal" | "bold" | "lighter" | number;
  fontStyle?: "normal" | "italic";
  textDecoration?: "none" | "underline" | "line-through";
  letterSpacing?: number;
  lineHeight?: number;
  textShadow?: TextShadow;
  textStroke?: TextStroke;
};

export type VbInsertDetail = {
  id?: string;
  title?: string;
  src: string;
  type: "video" | "image" | "audio" | "text" | "template";
  duration?: number;
  thumb?: string;
  mode?: VbInsertMode;
};

export function setVbInsertDetailOnDataTransfer(dt: DataTransfer, detail: VbInsertDetail) {
  dt.setData(VB_INSERT_DND_MIME, JSON.stringify(detail));
  // Also set plain text so drops into text fields don’t crash (ignored by our handlers)
  dt.setData("text/plain", detail.title || detail.type);
}

export function getVbInsertDetailFromDataTransfer(dt: DataTransfer): VbInsertDetail | null {
  const raw = dt.getData(VB_INSERT_DND_MIME);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<VbInsertDetail> | null;
    if (!parsed || typeof parsed !== "object") return null;
    if (typeof parsed.src !== "string" || !parsed.src) return null;
    if (parsed.type !== "video" && parsed.type !== "image" && parsed.type !== "audio" && parsed.type !== "text" && parsed.type !== "template") {
      return null;
    }
    if (parsed.mode && parsed.mode !== "append" && parsed.mode !== "replace-placeholder") return null;
    return parsed as VbInsertDetail;
  } catch {
    return null;
  }
}

export function tryParseVbTextAssetPayload(src: string): VbTextAssetPayload | null {
  if (!src || typeof src !== "string") return null;
  if (src[0] !== "{") return null;
  try {
    const parsed = JSON.parse(src) as Partial<VbTextAssetPayload> | null;
    if (!parsed || typeof parsed !== "object") return null;
    if (typeof parsed.text !== "string") return null;
    return parsed as VbTextAssetPayload;
  } catch {
    return null;
  }
}

